import createAction from 'redux-actions/lib/createAction';

export const SET_CURRENT_USER = 'user/SET_USER';
export const SET_PRIVACY_STATUS = 'user/SET_PRIVACY_STATUS';

export const setCurrentUser = createAction(SET_CURRENT_USER);
export const setPrivacyStatus = createAction(SET_PRIVACY_STATUS);
